




































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator'
import Question from '@/components/question.vue'
import { Faq } from '@/interfaces/faq.interface'
import vel from 'vue-element-loading'

import register from '@/assets/svg/register.svg?inline'
import unregister from '@/assets/svg/unregister.svg?inline'
import check from '@/assets/svg/check.svg?inline'
import reregister from '@/assets/svg/reregister.svg?inline'
import { TranslateResult } from 'vue-i18n'

// noinspection JSUnusedGlobalSymbols
@Component({
  components: {
    Question,
    register,
    unregister,
    check,
    reregister,
    vel,
    Modal: () => import('@/components/modal.vue'),
    Sms: () => import('@/components/sms.vue')
  }
})
export default class Index extends Vue {
  public $mq: any
  public articles: Faq[] = []
  public iin: string = ''
  public msisdn: string = ''
  public prevMsisdn: string = ''
  public prevOwner: string = ''
  public active: boolean = false
  public otp: string = ''
  public imei: string = ''

  public iinState: boolean | null = null
  public msisdnState: boolean | null = null
  public prevMsisdnState: boolean | null = null
  public prevOwnerState: boolean | null = null
  public imeiState: boolean | null = null
  public prevOwnerDocType: number | null = null
  public type: number | null = null

  // response messages
  public successMessage: string = ''
  public errorMessage: string = ''

  // regsiter modal and steps
  public showRegisterModal: boolean = false
  public registerModalOtp: boolean = false

  // unregister modal and steps
  public showUnregisterModal: boolean = false
  public unregisterModalOtp: boolean = false

  // device list modal and steps
  public showListModal: boolean = false
  public listModalOtp: boolean = false
  public deviceList: any = []

  // check device modal and steps
  public showCheckModal: boolean = false

  // re register modal and steps
  public showReregisterModal: boolean = false
  public reregisterModalOtp: boolean = false

  // noinspection JSUnusedLocalSymbols,JSMethodCanBeStatic
  private created(): void {
    this.fetchFaq()
    this.getAuthNumber()
  }

  // noinspection JSMethodCanBeStatic,JSUnusedLocalSymbols
  private mounted(): void {
    /*
    * get window height on mobile
    * */
    if (this.$mq !== 'desktop') {
      const windowHeight = window.innerHeight - 200
      document.documentElement.style.setProperty(
        '--windowHeight',
        `${windowHeight}px`
      )
    }

    window.addEventListener('resize', () => {
      document.body.style.height = window.innerHeight + 'px'
    })

    switch (this.$route.query.type) {
      case 'register':
        if (this.$route.query.iin) {
          this.iin = this.$route.query.iin as string
          this.validateField('iinState', this.iin)
        }
        this.showRegisterModal = true
        if (this.$route.query.msisdn) {
          this.msisdn = (this.$route.query.msisdn as string).replace(
            /^7/gi,
            ''
          )
          this.validateField('msisdnState', this.msisdn)
        }
        break
      case 're-register':
        this.showReregisterModal = true
        if (this.$route.query.iin) {
          this.iin = this.$route.query.iin as string
          this.validateField('iinState', this.iin)
        }
        this.showRegisterModal = true
        if (this.$route.query.msisdn) {
          this.msisdn = (this.$route.query.msisdn as string).replace(
            /^7/gi,
            ''
          )
          this.validateField('msisdnState', this.msisdn)
        }
        break
      case 'unregister':
        this.showUnregisterModal = true
        if (this.$route.query.iin) {
          this.iin = this.$route.query.iin as string
        }
        if (this.$route.query.msisdn) {
          this.msisdn = (this.$route.query.msisdn as string).replace(
            /^7/gi,
            ''
          )
        }
        break
      case 'device-list':
        this.showListModal = true
        if (this.$route.query.msisdn) {
          this.msisdn = (this.$route.query.msisdn as string).replace(
            /^7/gi,
            ''
          )
        }
        break
      case 'check':
        this.showCheckModal = true
        if (this.$route.query.imei) {
          this.imei = (this.$route.query.imei as string)
          this.validateField('imeiState', this.imei)
        }
        break
    }
  }

  // noinspection JSUnusedLocalSymbols
  private openModal(type: string) {
    document.querySelector('body')!.classList.add('no-scroll')
    switch (type) {
      case 'showRegisterModal':
        this.showRegisterModal = true
        break
      case 'showUnregisterModal':
        this.showUnregisterModal = true
        break
      case 'showListModal':
        this.showListModal = true
        break
      case 'showReregisterModal':
        this.showReregisterModal = true
        break
      case 'showCheckModal':
        this.showCheckModal = true
        break
    }
  }

  private onPaste(evt: { clipboardData: { getData: (arg0: string) => string } }, modelValue: string) {
    let numberText = evt.clipboardData.getData('text').replace(/[^0-9]/g,"")      
      if(numberText.length > 10) {
        numberText = numberText.slice(1)
      }

      if(numberText.length > 8) {
        setTimeout(() => {
          if(modelValue == 'msisdn') {
            this.msisdn = numberText
          } else {
            this.prevMsisdn = numberText
          }
        }, 0);
      }
    }


  // noinspection JSMethodCanBeStatic,JSUnusedLocalSymbols
  private validateField(fieldStateType: string, e: string) {    
    if (
      fieldStateType === 'msisdnState' ||
      fieldStateType === 'prevMsisdnState'
    ) {
      // TODO: might improve validation logic
      // noinspection JSUnnecessarySemicolon
      ;(this as any)[fieldStateType] = e.length === 10 || null
    } else {
      // noinspection JSUnnecessarySemicolon
      ;(this as any)[fieldStateType] = (e.length >= 8 && e.length <= 12) || null
    }
    if (fieldStateType === 'imeiState') {
      const onlyDigits = new RegExp(/^\d+$/);
      (this as any)[fieldStateType] = ((e.length === 15) || null) && onlyDigits.test(e)
    }
  }

  // noinspection JSUnusedLocalSymbols,JSMethodCanBeStatic
  private getDocTypeLabel(value: number) {
    let label: TranslateResult = ''
    switch (value) {
      case 1:
        label = this.$t('fields.prevOwner.iin')
        break
      case 2:
        label = this.$t('fields.prevOwner.bin')
        break
      case 3:
        label = this.$t('fields.prevOwner.rnn')
        break
      case 4:
        label = this.$t('fields.prevOwner.id')
        break
      case 5:
        label = this.$t('fields.prevOwner.passportResident')
        break
      case 6:
        label = this.$t('fields.prevOwner.passportNonResident')
        break
    }
    return label
  }

  // noinspection JSUnusedLocalSymbols
  private closeModal(type: string) {
    document.querySelector('body')!.classList.remove('no-scroll')
    // reset all data
    this.iin = ''
    this.msisdn = ''
    this.otp = ''
    this.imei = ''
    this.successMessage = ''
    this.errorMessage = ''
    this.deviceList = []
    this.iinState = null
    this.msisdnState = null
    this.prevMsisdnState = null
    this.prevOwnerState = null
    this.prevMsisdn = ''
    this.prevOwner = ''
    this.prevOwnerDocType = null
    this.registerModalOtp = false
    this.unregisterModalOtp = false
    this.listModalOtp = false
    this.reregisterModalOtp = false
    this.type = null

    switch (type) {
      case 'showRegisterModal':
        this.showRegisterModal = false
        break
      case 'showUnregisterModal':
        this.showUnregisterModal = false
        break
      case 'showListModal':
        this.showListModal = false
        break
      case 'showReregisterModal':
        this.showReregisterModal = false
        break
      case 'showCheckModal':
        this.showCheckModal = false
        break
    }
  }

  // noinspection JSUnusedLocalSymbols
  private registerDevice(): Promise<any> {
    // noinspection JSUnusedGlobalSymbols
    this.active = true
    return this.$http
      .registerRequest(
        this.$i18n.locale.toUpperCase(),
        '7' + this.msisdn,
        this.iin.trim()
      )
      .then(() => {
        this.registerModalOtp = true
        this.errorMessage = ''
      })
      .catch((err: any) => {
        this.errorMessage = err.response.data.text[this.$i18n.locale]
      })
      .finally(() => {
        this.active = false
      })
  }

  // noinspection JSUnusedLocalSymbols
  private confirmRegister(otp: string): Promise<any> {
    this.active = true
    return this.$http
      .confirmRegister('7' + this.msisdn, otp)
      .then((resp: any) => {
        this.errorMessage = ''
        this.successMessage = resp.data.text[this.$i18n.locale]
      })
      .catch((err: any) => {
        this.errorMessage = err.response.data.text[this.$i18n.locale]
      })
      .finally(() => {
        this.active = false
      })
  }

  // noinspection JSUnusedLocalSymbols
  private unregisterDevice(): Promise<any> {
    // noinspection JSUnusedGlobalSymbols
    this.active = true
    return this.$http
      .unregisterRequest(
        this.$i18n.locale.toUpperCase(),
        '7' + this.msisdn,
        this.iin
      )
      .then(() => {
        this.unregisterModalOtp = true
        this.errorMessage = ''
      })
      .catch((err: any) => {
        this.errorMessage = err.response.data.text[this.$i18n.locale]
      })
      .finally(() => {
        this.active = false
      })
  }

  // noinspection JSUnusedLocalSymbols
  private confirmUnregister(otp: string): Promise<any> {
    this.active = true
    return this.$http
      .confirmUnregister('7' + this.msisdn, otp)
      .then((resp: any) => {
        this.errorMessage = ''
        this.successMessage = resp.data.text[this.$i18n.locale]
      })
      .catch((err: any) => {
        this.errorMessage = err.response.data.text[this.$i18n.locale]
      })
      .finally(() => {
        this.active = false
      })
  }

  // noinspection JSUnusedLocalSymbols
  private listRequest(): Promise<any> {
    // noinspection JSUnusedGlobalSymbols
    this.active = true
    return this.$http
      .listRequest(this.$i18n.locale.toUpperCase(), '7' + this.msisdn)
      .then(() => {
        this.listModalOtp = true
        this.errorMessage = ''
      })
      .catch((err: any) => {
        this.errorMessage = err.response.data.text[this.$i18n.locale]
      })
      .finally(() => {
        this.active = false
      })
  }

  // noinspection JSUnusedLocalSymbols
  private confirmList(otp: string): Promise<any> {
    this.active = true
    return this.$http
      .confirmList('7' + this.msisdn, otp)
      .then((resp: any) => {
        this.deviceList = resp.data
        this.errorMessage = ''
        this.$router.push({
          name: 'deviceList',
          params: { devices: resp.data, msisdn: '7' + this.msisdn }
        })
      })
      .catch((err: any) => {
        this.errorMessage = err.response.data.text[this.$i18n.locale]
      })
      .finally(() => {
        this.active = false
      })
  }

  // noinspection JSUnusedLocalSymbols
  private reregisterRequest(): Promise<any> {
    // noinspection JSUnusedGlobalSymbols
    this.active = true
    return this.$http
      .reregisterRequest(
        this.$i18n.locale.toUpperCase(),
        '7' + this.msisdn,
        this.iin,
        '7' + this.prevMsisdn,
        this.prevOwnerDocType,
        this.prevOwner,
        this.type
      )
      .then(() => {
        this.reregisterModalOtp = true
        this.errorMessage = ''
      })
      .catch((err: any) => {
        this.errorMessage = err.response.data.text[this.$i18n.locale]
      })
      .finally(() => {
        this.active = false
      })
  }

  // noinspection JSUnusedLocalSymbols
  private confirmReregister(otp: string): Promise<any> {
    this.active = true
    return this.$http
      .confirmReregister('7' + this.msisdn, otp)
      .then((resp: any) => {
        this.errorMessage = ''
        this.successMessage = resp.data.text[this.$i18n.locale]
      })
      .catch((err: any) => {
        this.errorMessage = err.response.data.text[this.$i18n.locale]
      })
      .finally(() => {
        this.active = false
      })
  }

  private checkDevice(): Promise<any> {
    this.active = true
    return this.$http
      .checkDevice(this.imei)
      .then((resp: any) => {
        this.errorMessage = ''
        if (resp.data) {
          this.successMessage = this.$t('modalCheck.true') as string
        } else {
          this.successMessage = this.$t('modalCheck.false') as string
        }
      })
      .catch(() => {
        this.errorMessage = this.$t('modalCheck.error') as string
      })
      .finally(() => {
        this.active = false
      })
  }

  // noinspection JSMethodCanBeStatic,JSUnusedLocalSymbols
  private fetchFaq(): Promise<any> {
    this.active = true
    return this.$http
      .getFaqArticles(9)
      .then((resp: any) => {
        this.articles = resp.data
      })
      .catch((err: string) => {
        console.error(err)
      })
      .finally(() => {
        this.active = false
      })
  }

  // noinspection JSUnusedLocalSymbols
  private getAuthNumber(): Promise<any> {
    this.active = true
    return this.$http
      .getAuthNumber()
      .then((resp: { data: string }) => {
        this.msisdn = resp.data.replace(/^7/gi, '')
        this.validateField('msisdnState', this.msisdn)
      })
      .catch((err: any) => {
        console.error(err)
      })
      .finally(() => {
        this.active = false
      })
  }
}
